import React, { useState, useEffect } from "react";
import useAuth from "../hooks/useAuth";
import VacancySummary from "../components/information_cards/vacancySummary";
import VacancyTable from "../components/applications/table/vacancyTable";
import Footer from "../components/Navbars/footer";

function VacancySettings() {
  const { auth } = useAuth();

  return (
    <div className="flex min-h-screen flex-col">
      <div className="w-full max-w-[95%] 2xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 flex-1">
        <div className="">
          <VacancySummary />
        </div>
        <main className="">
          <div className="flex space-x-4 ">
            <VacancyTable />
          </div>
        </main>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default VacancySettings;
